<template>
  <v-app>
    <SkipLink />
    <v-main>
      <header>
        <v-container class="d-flex flex-row">
          <div>
            <v-icon color="white" @click="$router.push('/station')">
              mdi-home
            </v-icon>
          </div>
          <div
            class="ml-auto font-weight-bold"
            v-if="$route.name != 'station'"
            @click="$router.push('/station/scan')"
          >
            {{ $store.state.station.type }}站
          </div>
        </v-container>
      </header>
      <h1
        id="main-content"
        tabindex="-1"
        class="text-h5 font-weight-bold text-center mt-6 mb-0"
      >
        {{ $city.name }}成人健康篩檢站點
      </h1>
      <div
        v-if="$store.state.station.person.reservation"
        class="text-h6 text-center mt-1"
      >
        {{ $store.state.station.person.reservation.身分證字號 }} ({{
          $store.state.station.person.reservation.姓名
        }})
      </div>
      <v-container>
        <router-view />
      </v-container>
      <v-dialog v-model="scan.dialog">
        <qrcode-stream @decode="onDecode" :camera="scan.camera">
        </qrcode-stream>
      </v-dialog>
    </v-main>
  </v-app>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import station from "@/mixins/station";
import SkipLink from "@/components/Common/SkipLink.vue";
export default {
  mixins: [station],
  components: {
    SkipLink,
  },
  computed: {
    ...mapFields(["station.scan", "station.person"]),
  },
  created() {
    this.scan.dialog = false;
  },
  methods: {
    async onDecode(_id) {
      this.scan.dialog = false;
      this.person = (await this.axios.get(`/person`, { params: { _id } })).data;
      this.goStation();
    },
  },
  watch: {
    "scan.dialog"(value) {
      this.scan.camera = value ? "rear" : "off";
    },
  },
};
</script>

<style lang="scss" scoped>
header {
  background-color: #0f4c81;
  color: #fff;
  // line-height: 52px;
}
</style>
